<template>
  <v-dialog v-model="dialog" width="750" persistent>
    <v-card>
      <!-- <v-banner sticky class="primary custom-padding py-0">
        <v-row class="text-left pb-0">
          <v-col cols="12" class="py-3">
            <span class="white--text custom-title">Order Status</span>
          </v-col>
          <v-col>
        <v-btn
          color="primary"
           @click="$emit('closeDialog')"
        >
          Close
        </v-btn>
      </v-col>
        </v-row>
        
      </v-banner> -->
      <v-toolbar dark color="primary">
        <v-toolbar-title>Order Status</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="$emit('closeDialog')" dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pt-3">
        <v-row>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="12" md="4" class="text-center">
                Status
              </v-col>
              <v-col cols="12" md="8">
                {{ status }}
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="12" md="4" class="text-center">
                Reason Code
              </v-col>
              <v-col cols="12" md="8">
                {{ reason }}
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="12" md="4" class="text-center">
                Description
              </v-col>
              <v-col cols="12" md="8">
                {{ description }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "order-status",
  props: {
    dialog: { type: Boolean, required: true },
    orderId: { type: String, required: true }
  },
  data: () => ({
    status: "",
    reason: "",
    description: ""
  }),
  methods: {
    async getOrderStatus() {
      let vm = this;
      let res = await vm.$HTTP.post("NbnNotification/GetNbnNotifiication", {
        orderId: this.orderId
      });
      const body = JSON.parse(res.data.body);
      vm.status = `${body.event.state} at ${body.eventTime}`;
      vm.reason = body.eventNote.code;
      vm.description = body.eventNote.reason;
    }
  },
  watch: {
    dialog: {
      immediate: true,
      async handler(newval) {
        if (newval) {
          await this.getOrderStatus();
        }
      }
    }
  }
};
</script>

<style scoped>
::v-deep .custom-padding .v-banner__wrapper {
  padding-bottom: 0px !important;
}

.custom-title {
  font-size: 20px;
  font-weight: bold;
}

.rtl {
  direction: rtl;
}

.fixed-bar {
  width: 100%;
  position: sticky;
  bottom: -1px;
}

::v-deep
  .fixed-bar
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #f5f5f5 !important;
}
</style>
